import * as Sentry from '@sentry/browser';

const sentryDsn = document.querySelector('meta[name="sentry-dsn"]')?.content;
if (sentryDsn) {
    Sentry.init({
        dsn: sentryDsn,
        environment: document.querySelector('meta[name="sentry-environment"]')?.content || 'development',
        tracesSampleRate: 0.1,
        // SDK 11 streams spans by default and officially requires Sentry self-hosted
        // >= 26.4.2. Our backend is GlitchTip (Sentry protocol); streamed spans are
        // unverified there, so keep the v10 transaction-based trace lifecycle.
        traceLifecycle: 'static',
        // SDK 11 collects more PII by default (user info, cookies, request bodies).
        // Pin the v10 baseline explicitly (DSGVO); see the v10->v11 migration guide.
        dataCollection: {
            userInfo: false,
            cookies: false,
            httpHeaders: {
                request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
                response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
            },
            httpBodies: [],
            urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
        },
    });
}

// Window assignments for inline PHP template handlers are now in each source file:
// - dc/common/common.js (toggle, toggleOn, toggleOff, etc.)
// - script*.js (toggle_mobile_menu)
